export enum FlagUpdateType {
  add = 'A',
  remove = 'D',
}
